module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rae Armantrout\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("RAE ARMANTROUT (Everett, WA) is the Pulitzer Prize winning author of fifteen books of poetry. She has published ten books with Wesleyan University Press, including "), _c('I', [_vm._v("Wobble, Entanglements, Partly")]), _vm._v(", and "), _c('I', [_vm._v("Versed")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/t6SHxI/tc-custom/9780819580696.jpg?1705290529332",
      "alt": "This image is the cover for the book Finalists"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Finalists\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A double book by Pulitzer Prize winning poet Rae Armantrout")])]), _c('p', [_vm._v(" What will we call the last generation before the looming end times? With"), _c('i', [_vm._v(" Finalists")]), _vm._v(" Rae Armantrout suggests one option. Brilliant and irascible, playful and intense, Armantrout nails the current moment's debris fields and super computers, its sizzling malaise and confusion, with an exemplary immensity of heart and a boundless capacity for humor. The poems in this book find (and create) beauty in midst of the ongoing crisis. ")]), _c('p', [_c('br'), _vm._v(" CONTRAST ")]), _c('p', [_c('br'), _vm._v(" What's to like"), _c('br'), _vm._v(" if not contrast? ")]), _c('p', [_vm._v(" Shadows beneath"), _c('br'), _vm._v(" the model's sharp ")]), _c('p', [_vm._v(" cheekbones, her ample"), _c('br'), _vm._v(" yet precise lips. ")]), _c('p', [_vm._v(" Clean lines separating"), _c('br'), _vm._v(" bounty"), _c('br'), _vm._v(" from its opposite. ")]), _c('p', [_vm._v(" This is not"), _c('br'), _vm._v(" what I want ")]), _c('p', [_vm._v(" to want. ")]), _c('p', [_vm._v(" These eyes"), _c('br'), _vm._v(" on the hypothetical ")]), _c('p', [_vm._v(" distance. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wesleyan University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0